import { shareIcon } from "assets/icons";
import {
  appImg1,
  appImg2,
  appImg3,
  FingertipsImg1,
  FingertipsImg2,
  FingertipsImg3,
  FingertipsImg4,
} from "assets/images";
import React from "react";
import { Link } from "react-router-dom";
import "./Features.scss";
import {
  faqs,
  featureAppCardsData,
  featureSurveyStepsData,
} from "constant/staticData";
import { useTranslation } from "react-i18next";
const Features = () => {
  const { t } = useTranslation();

  const SurveyStep = ({ image, title, description }) => {
    return (
      <div className="survey_steps">
        <div className="image_Wrap">
          <img src={image} alt={title} />
        </div>
        <div className="content">
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      </div>
    );
  };

  const AppCard = ({ image, title, description, linkText, link }) => {
    return (
      <div className="item">
        <div className="_card">
          <img src={image} alt={title} />
          <div className="content">
            <h4>{title}</h4>
            <p>{description}</p>
            <Link to={link}>
              {linkText} <img src={link.icon} alt="share icon" />
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="home_page websites_features">
      <div className="features_details">
        <div className="design_survey_steps spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                {t(`FEATURESTEPDATA.designSurveyFingertips`)}
                <span>{t(`FEATURESTEPDATA.fingertips`)}</span>.
              </h3>
            </div>
            {featureSurveyStepsData.map((step, index) => (
              <SurveyStep
                key={`featureSurveyStepsData-${index}`}
                image={step.image}
                title={t(`FEATURESTEPDATA.featuredata-title-${index}`)}
                description={t(
                  `FEATURESTEPDATA.featuredata-description-${index}`
                )}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="seamless_survey spacing">
        <div className="container">
          <div className="page_title">
            <h3>
              <span> {t(`FEATURESTEPDATA.seamlessSurvey`)}</span>{" "}
              {t(`FEATURESTEPDATA.empoweringClientParticipant`)}
            </h3>
          </div>
          <div className="card_wrap">
            {featureAppCardsData.map((card, index) => (
              <AppCard
                key={`featureAppCardsData-${index}`}
                image={card.image}
                title={t(`FEATURESTEPDATA.featureappdata-title-${index}`)}
                description={t(
                  `FEATURESTEPDATA.featureappdata-description-${index}`
                )}
                linkText={t(`FEATURESTEPDATA.featureappdata-linkText-${index}`)}
                link={card.link}
              />
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}

      <div className="faqs spacing">
        <div className="container">
          <div className="page_title">
            <h3>
              {t(`FEATURESTEPDATA.exploreOur`)}{" "}
              <span> {t(`FEATURESTEPDATA.faq`)}</span>
            </h3>
            <p>{t(`FEATURESTEPDATA.faqDescription`)}</p>
          </div>

          <div className="card_wrap">
            {faqs.map((faq, index) => (
              <div className="item" key={faq?.key || index}>
                <div className="faq_card">
                  <img src={faq?.image || ""} alt={`FAQ ${faq.key}`} />
                  <div className="content">
                    <h5>
                      {t(`FEATURESTEPDATA.featureFaq-title-${index}`) || ""}
                    </h5>
                    <p>
                      {t(`FEATURESTEPDATA.featureFaq-description-${index}`) ||
                        ""}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
